import * as React from "react";
import { forwardRef } from "react";
const SvgIcTension40 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "icSign-tension" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M22.5 17.1727L22.4999 2.5L12.5 24.3749L18.75 22.6823L18.7501 37.5L27.5 15.6251L22.5 17.1727Z", fill: "currentColor" })));
const ForwardRef = forwardRef(SvgIcTension40);
export { ForwardRef as ReactComponent };
